import { render, staticRenderFns } from "./SpOrdering.vue?vue&type=template&id=2bd3c64d&scoped=true&"
import script from "./SpOrdering.vue?vue&type=script&lang=js&"
export * from "./SpOrdering.vue?vue&type=script&lang=js&"
import style0 from "./SpOrdering.vue?vue&type=style&index=0&id=2bd3c64d&scoped=true&lang=css&"
import style1 from "./SpOrdering.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3c64d",
  null
  
)

export default component.exports